import { useState } from "react";
import {
  closeButtonDiv,
  controlButtonWrapper,
  controlButton,
} from "./MapButtonStyling";

const MapCloseButton = () => {
  const [hover, setHover] = useState(false);

  const handleClose = () => {
    if (window.confirm("Are you sure you want to close the map?")) {
      window.close();
    } else {
      return;
    }
  };

  return (
    <div style={closeButtonDiv}>
      <div style={controlButtonWrapper}>
        <button
          onMouseEnter={() => setHover("close")}
          onMouseLeave={() => setHover(false)}
          onClick={handleClose}
          style={controlButton(hover === "close")}
        >
          Close
        </button>
      </div>
    </div>
  );
};

export default MapCloseButton;
